import ActiveRecord from './active_record/base'

export class ApiConsumer extends ActiveRecord {
	static tableName = 'apiConsumers'
}
